var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79083 1.79102 0 4 0H12C14.209 0 16 1.79083 16 4V12C16 14.2092 14.209 16 12 16H4C1.79102 16 0 14.2092 0 12V4ZM2 2.75C2 2.33579 2.33579 2 2.75 2H13.25C13.6642 2 14 2.33579 14 2.75V6.5H13.25V3.5H12.5V6.5H11.75V5H11V6.5H10.25V3.5H9.5V6.5H8.75V5H8V6.5H7.25V3.5H6.5V6.5H3.5V7.25H6.5V8H5V8.75H6.5V9.5H3.5V10.25H6.5V11H5V11.75H6.5V12.5H3.5V13.25H6.5V14H2.75C2.33579 14 2 13.6642 2 13.25V2.75Z",
    fill: "#43A047"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.1d9d045f461aaf6d7fb1ae32072c8cc1.svg";
export { ForwardRef as ReactComponent };